// This file is automatically generated. Do not edit it directly.
import { createMiddleware } from '@tanstack/react-start'

// Must be registered as a global `functionMiddleware` in `src/start.ts`; otherwise
// the browser never attaches the bearer token to serverFn RPCs.
//
// PERF: `./client` é carregado com import() dinâmico dentro do handler em vez de
// import estático no topo. `start.ts` faz parte do grafo do cliente, então o
// import estático arrastava todo o @supabase/supabase-js (auth-js + realtime +
// phoenix) para o chunk de entrada, baixado em toda visita mesmo sem nenhum
// serverFn ser chamado. O comportamento em runtime é idêntico: o middleware
// continua registrado, continua rodando e continua anexando o mesmo header
// Authorization — o módulo só é buscado na primeira invocação real.
export const attachSupabaseAuth = createMiddleware({ type: 'function' }).client(
  async ({ next }) => {
    const { supabase } = await import('./client')
    const { data } = await supabase.auth.getSession()
    const token = data.session?.access_token
    return next({
      headers: token ? { Authorization: `Bearer ${token}` } : {},
    })
  },
)
